module.exports = __webpack_public_path__ + "static/img/SoftwareSupportDetail_content_two.10420f9d.png";